import { BankingReconciliationSidePanelDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

import NewReconciliationPageFromInvoice from 'modules/banking/pages/NewReconciliationPageFromInvoice'
import { ReconciliationFromFinancialDocumentSidePanel } from 'modules/finance/components/ReconciliationFromFinancialDocumentSidePanel'

const BankingReconciliationFromInvoiceSidePanel = () => {
  const { data } = useQuery(BankingReconciliationSidePanelDocument)

  if (!data) return null

  const reconcileWithJournalLines =
    data?.banking?._policies.reconciliationsSeeJournalEntriesPage.can ?? false

  return reconcileWithJournalLines ? (
    <ReconciliationFromFinancialDocumentSidePanel />
  ) : (
    <NewReconciliationPageFromInvoice />
  )
}

export default BankingReconciliationFromInvoiceSidePanel
